/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CatalogDto } from './CatalogDto';
import {
    CatalogDtoFromJSON,
    CatalogDtoFromJSONTyped,
    CatalogDtoToJSON,
    CatalogDtoToJSONTyped,
} from './CatalogDto';

/**
 * 
 * @export
 * @interface CatalogResponse
 */
export interface CatalogResponse {
    /**
     * 
     * @type {CatalogDto}
     * @memberof CatalogResponse
     */
    data?: CatalogDto;
}

/**
 * Check if a given object implements the CatalogResponse interface.
 */
export function instanceOfCatalogResponse(value: object): value is CatalogResponse {
    return true;
}

export function CatalogResponseFromJSON(json: any): CatalogResponse {
    return CatalogResponseFromJSONTyped(json, false);
}

export function CatalogResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CatalogResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CatalogDtoFromJSON(json['data']),
    };
}

export function CatalogResponseToJSON(json: any): CatalogResponse {
    return CatalogResponseToJSONTyped(json, false);
}

export function CatalogResponseToJSONTyped(value?: CatalogResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CatalogDtoToJSON(value['data']),
    };
}

